import {toAbsoluteUrl} from '_metronic/helpers'
import InfoCard from './InfoCard'
import {DrawerContentProps} from '../utils/types'
import {useEffect, useState} from 'react'
import db from 'services/firebase'
import TestsControlsModal from '../modals/TestsControlsModal'


export const DrawerContent: React.FC<DrawerContentProps> = ({
  title,
  description,
  logo,
  integration,
  openAccordion,
  setOpenAccordion,
  openAccordion2,
  setOpenAccordion2,
  permissionInfo,
  accessTypeinfo,
}) => {
  const isConnected = integration.length > 0 && integration[0]?.status === 'Connected'
  const [defaultIntegrations, setDefaultIntegrations] = useState<any[]>([])
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    const collectionRef = db.collection('integrations')

    const unsubscribe = collectionRef.onSnapshot((snapshot) => {
      const integrations: any[] = []
      snapshot.forEach((doc) => {
        const data = doc.data()
        integrations.push(data)
      })
      const filtered = integrations.filter((item) => item?.name === integration[0]?.name)
      setDefaultIntegrations(filtered)
    })
  }, [integration])

  return (
    <>
      <div className='card-header border-0 mb-4'>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center'>
            <div className='symbol symbol-45px me-5'>
              <img src={toAbsoluteUrl(logo)} alt='' />
            </div>
            <div className='d-flex justify-content-start flex-column'>
              <span className='card-label fw-bold fs-5'>{title}</span>
              <span className='fw-semibold fs-6' style={{color: '#5A5A5A'}}>
                {description}
              </span>
            </div>
          </div>
          {isConnected ? (
            <span className='badge border border-2 p-2 rounded-pill'>
              <span
                className='badge border rounded-circle mx-2 bg-primary'
                style={{
                  width: '12px',
                  height: '12px',
                  padding: '3px',
                }}
              >
                {' '}
              </span>
              <span className='text-center'>Connected</span>
            </span>
          ) : (
            <span className='badge border border-2 p-2 rounded-pill'>
              <span
                className='badge border rounded-circle mx-2 bg-danger'
                style={{
                  width: '12px',
                  height: '12px',
                  padding: '3px',
                }}
              >
                {' '}
              </span>
              <span className='text-center'>Not Connected</span>
            </span>
          )}
        </div>
      </div>
      <label className='text-dark fw-bold text-primary my-2 fs-6 mb-4'>
        Mapped Controls & Tests
      </label>
      {title === 'Google Cloud Platform' ? (
        <>
          <div className='card mb-4 p-4' style={{background: '#F6F6F6'}}>
            <div className='fs-6 fw-bold text-bold'>Automation</div>
            <div className='fs-6 fw-semibold mt-2' style={{color: '#5A5A5A'}}>
              <ul>
                <li>
                  <a href={`/vulnerabilities/clouds/${integration[0]?.cloudId}/checks`} rel='noopener noreferrer'>
                  Automated Tests and Controls{' '}
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    className='icon icon-tabler icons-tabler-outline icon-tabler-external-link mb-1 me-1'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <path d='M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6' />
                    <path d='M11 13l9 -9' />
                    <path d='M15 4h5v5' />
                  </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='card mb-4 p-4' style={{background: '#F6F6F6'}}>
            <div className='fs-6 fw-bold text-bold'>Automation</div>
            <div className='fs-6 fw-semibold mt-2' style={{color: '#5A5A5A'}}>
              <ul>
                <li 
                  style={{cursor: 'pointer'}}
                  onClick={() => setShowModal(true)}
                >
                  <span className='text-primary'>
                  Automated Tests and Controls{' '}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}
      <div className='separator my-6'></div>

      <InfoCard type='permission' title='Permissions' description={permissionInfo} />
      <InfoCard type='access' title='Access Type' description={accessTypeinfo} />

      <div className='separator my-6'></div>

      <TestsControlsModal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={`Automated Tests and Controls for ${title}`}
        controlsData={defaultIntegrations[0]?.Controls ? defaultIntegrations[0]?.Controls :defaultIntegrations[0]?.controls}
        testsData={defaultIntegrations[0]?.tests}
        testsCount={2}
      />
    </>
  )
}
